var _rect, _path, _path2, _rect2, _g, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _rect5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602,
    height: 396,
    viewBox: "0 0 602 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 190,
    rx: 25.98,
    fill: "#FFD991"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6423 160.311C91.2442 160.667 89.0115 159.012 88.6554 156.614L92.9975 155.969C88.6554 156.614 88.6553 156.613 88.6552 156.613L88.6549 156.611L88.6539 156.604L88.6504 156.58L88.6376 156.492C88.6266 156.416 88.6106 156.305 88.5902 156.161C88.5493 155.872 88.4905 155.448 88.4172 154.9C88.2994 154.019 88.1442 152.817 87.9662 151.335C80.4318 150.2 65.42 143.616 58.3223 133.53C48.8518 122.001 44.0564 108.413 50.4994 108.413C56.9424 108.413 76.1648 120.217 84.6742 131.608C85.2081 132.096 85.736 132.643 86.2512 133.237C85.305 119.878 84.7742 102.453 86.4356 86.0237C86.6795 83.6116 88.8326 81.854 91.2446 82.0979C93.6567 82.3418 95.4143 84.4949 95.1704 86.907C93.5605 102.827 94.0921 119.92 95.0439 133.11C95.1209 134.176 95.2005 135.216 95.2818 136.227C101.062 128.314 110.026 120.886 117.899 116.285C128.967 108.31 149.15 98.0869 149.15 106.357C149.15 114.627 134.175 134.189 122.944 143.955C112.062 152.679 103.242 156.26 97.3602 156.465C97.1424 158.394 95.6536 160.013 93.6423 160.311Z",
    fill: "#609185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.241 73.7804C122.074 105.205 92.6818 111.927 89.3789 111.693C86.076 111.459 43.7853 90.9021 43.7853 67.6152C45.1653 47.3688 62.2569 26.8147 87.4204 57.2953C112.863 13.5476 142.42 54.9446 134.241 73.7804Z",
    fill: "#F35E54"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    width: 190,
    height: 190,
    rx: 24,
    fill: "url(#paint0_linear_107_254)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_254)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412,
    width: 190,
    height: 190,
    rx: 25.98,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_107_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.473 -19.3783C417.593 -47.7498 489.514 -47.0939 517.984 -26.9043C546.455 -6.71464 548.588 97.8906 528.469 126.262C508.349 154.634 411.672 124.998 383.202 104.808C354.731 84.6188 377.354 8.99321 397.473 -19.3783Z",
    fill: "#1A708B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_107_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.986 103.721C499.986 137.056 444.382 204.725 410.586 204.725C376.79 204.725 313.675 172.59 313.675 139.255C313.675 105.92 398.095 32.8418 431.891 32.8418C465.687 32.8418 499.986 70.3854 499.986 103.721Z",
    fill: "#A7D5E8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_107_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.884 189.258C367.869 178.702 491.851 89.6821 507.594 41.9336C523.337 -5.8148 540.25 -57.989 606.954 -35.9961C638.969 -25.4405 628.264 36.5826 612.521 84.3311C596.777 132.08 431.899 199.813 399.884 189.258Z",
    fill: "#DB7F43"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_107_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.336 217.524C619.336 258.369 554.375 254.502 528.475 254.502C502.575 254.502 429.107 235.669 429.107 194.824C429.107 153.979 536.725 174.136 610.479 84.9805C636.379 84.9805 619.336 176.678 619.336 217.524Z",
    fill: "#FADF7E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M507.475 27.0751C507.475 27.0751 510.972 61.9337 525.519 76.4808C540.066 91.0279 574.925 94.5251 574.925 94.5251C574.925 94.5251 540.066 98.4972 525.519 113.044C510.972 127.591 507.475 162.688 507.475 162.688C507.475 162.688 503.503 127.591 488.956 113.044C474.409 98.4972 439.312 94.5251 439.312 94.5251C439.312 94.5251 474.409 91.0279 488.956 76.4808C503.503 61.9337 507.475 27.0751 507.475 27.0751Z",
    fill: "#FFFCF7"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 206,
    width: 190,
    height: 190,
    rx: 24,
    fill: "url(#paint1_linear_107_254)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 206,
    width: 190,
    height: 190,
    rx: 25.98,
    fill: "url(#paint2_linear_107_254)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M350.479 299.516C350.479 326.842 328.327 348.995 301 348.995C273.673 348.995 251.521 326.842 251.521 299.516C251.521 272.189 273.673 250.036 301 250.036C328.327 250.036 350.479 272.189 350.479 299.516ZM261.417 299.516C261.417 321.377 279.139 339.099 301 339.099C322.861 339.099 340.583 321.377 340.583 299.516C340.583 277.654 322.861 259.932 301 259.932C279.139 259.932 261.417 277.654 261.417 299.516Z",
    fill: "url(#paint3_linear_107_254)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301 254.984C301 252.252 303.221 250.011 305.94 250.284C314.401 251.133 322.532 254.152 329.526 259.087C337.872 264.976 344.191 273.303 347.616 282.927C351.04 292.55 351.403 302.998 348.653 312.836C345.903 322.673 340.176 331.419 332.257 337.871C324.339 344.324 314.618 348.168 304.428 348.876C294.237 349.584 284.078 347.12 275.344 341.823C266.61 336.527 259.729 328.657 255.646 319.294C252.224 311.448 250.908 302.875 251.784 294.417C252.066 291.699 254.709 289.976 257.385 290.527V290.527C260.062 291.079 261.751 293.698 261.538 296.422C261.033 302.867 262.112 309.366 264.717 315.338C267.983 322.829 273.488 329.125 280.475 333.362C287.462 337.599 295.59 339.57 303.742 339.004C311.894 338.438 319.671 335.363 326.006 330.2C332.341 325.038 336.922 318.042 339.122 310.172C341.322 302.302 341.032 293.943 338.293 286.245C335.553 278.546 330.497 271.884 323.82 267.173C318.497 263.416 312.35 261.047 305.935 260.241C303.224 259.9 301 257.717 301 254.984V254.984Z",
    fill: "#FBFDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M301 237.729C301 234.962 303.246 232.699 306.005 232.907C313.939 233.503 321.716 235.512 328.965 238.854C337.734 242.897 345.522 248.792 351.793 256.135C358.064 263.477 362.668 272.091 365.289 281.384C367.91 290.677 368.485 300.428 366.974 309.965C365.464 319.502 361.904 328.598 356.54 336.626C351.175 344.654 344.134 351.424 335.901 356.469C327.669 361.514 318.44 364.715 308.851 365.849C300.924 366.788 292.906 366.296 285.177 364.411C282.489 363.756 281.052 360.91 281.907 358.279V358.279C282.762 355.647 285.585 354.23 288.282 354.85C294.625 356.308 301.185 356.667 307.673 355.899C315.824 354.935 323.668 352.215 330.666 347.926C337.664 343.638 343.649 337.884 348.209 331.059C352.768 324.235 355.794 316.504 357.078 308.398C358.362 300.291 357.873 292.003 355.646 284.104C353.418 276.205 349.504 268.883 344.174 262.642C338.844 256.401 332.224 251.39 324.77 247.954C318.837 245.218 312.487 243.533 306.003 242.959C303.247 242.715 301 240.495 301 237.729V237.729Z",
    fill: "#FBFDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M367.797 299.516C367.797 336.407 337.891 366.312 301 366.312C264.109 366.312 234.203 336.407 234.203 299.516C234.203 262.625 264.109 232.719 301 232.719C337.891 232.719 367.797 262.625 367.797 299.516ZM244.223 299.516C244.223 330.873 269.643 356.293 301 356.293C332.357 356.293 357.777 330.873 357.777 299.516C357.777 268.158 332.357 242.738 301 242.738C269.643 242.738 244.223 268.158 244.223 299.516Z",
    fill: "url(#paint4_linear_107_254)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M305.267 302.747C302.883 305.739 298.525 306.232 295.532 303.849C292.54 301.465 292.047 297.106 294.431 294.114C296.815 291.122 307.316 284.294 315.65 278.598C312.442 287.587 307.651 299.755 305.267 302.747Z",
    fill: "#FBFDFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 206,
    width: 190,
    height: 190,
    rx: 24,
    fill: "url(#paint5_linear_107_254)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_107_254",
    x: 322.274,
    y: -88.9432,
    width: 266.982,
    height: 274.402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.75,
    result: "effect1_foregroundBlur_107_254"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_107_254",
    x: 266.175,
    y: -14.6582,
    width: 281.311,
    height: 266.883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.75,
    result: "effect1_foregroundBlur_107_254"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_107_254",
    x: 338.961,
    y: -96.8435,
    width: 344.401,
    height: 342.865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.832,
    result: "effect1_foregroundBlur_107_254"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_107_254",
    x: 381.607,
    y: 37.4805,
    width: 290.732,
    height: 264.62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.75,
    result: "effect1_foregroundBlur_107_254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_254",
    x1: 301,
    y1: 190,
    x2: 301,
    y2: 8.99658e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_254",
    x1: 95,
    y1: 206,
    x2: 95,
    y2: 396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_254",
    x1: 206,
    y1: 206,
    x2: 396,
    y2: 396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.262175,
    stopColor: "#6E78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A55A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_107_254",
    x1: 301,
    y1: 250.036,
    x2: 258.231,
    y2: 293.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFDFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_107_254",
    x1: 247.47,
    y1: 257.396,
    x2: 277.343,
    y2: 366.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFDFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_107_254",
    x1: 507,
    y1: 206,
    x2: 507,
    y2: 396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_254"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412,
    width: 190,
    height: 190,
    rx: 25.98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.9e6c1acda684a12ecb5543233d9eedf8.svg";
export { ForwardRef as ReactComponent };